module.exports = "Emergency Kit\n\n# Sizzle\n\n## Content\n\n### Activity: Popcorn!\n#### Make a Plan\n\n## Notes\n&nbsp;\n\n# Instructions\n\n## Content\n\n### What needs to be included in your plan?\n\n## Notes\n\n&nbsp;\n\n\n# Answers\n\n## Content\n\n### Some possible answers:\n* Your meeting place\n* A plan for each family member\n* Written contact info\n* A plan for your pets\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/40_classActivity/level1b_makeAPlan.md
// module id = 1527
// module chunks = 2